export default __webpack_public_path__ + "2a01bad.png";